<div class="sponsor-modal">
    <button class="sponsor-modal__close" type="button" (click)="modalRef.hide()" [attr.aria-label]="'cart.button.close' | translate">
        <i class="fa-solid fa-xmark"></i>
    </button>

    <div class="sponsor-modal__body">
        <h2 class="sponsor-modal__title" translate="cart.attribution.modal.title"></h2>
        <p class="sponsor-modal__subtitle" translate="cart.attribution.modal.subtitle"></p>

        <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="sponsor-modal__field">
                <label class="sponsor-modal__label" translate="cart.attribution.modal.input.label"></label>
                <input class="sponsor-modal__input" type="text" formControlName="subdomain"
                       placeholder="{{ 'cart.attribution.modal.input.placeholder' | translate }}" autocomplete="off" />
                @if (showError) {
                    <span class="error-text" translate="cart.attribution.modal.error"></span>
                }
            </div>

            <button class="button button-black button-large full-width sponsor-modal__submit" type="submit" [disabled]="form.invalid || loading">
                @if (loading) {
                    <span class="fa fa-spinner fa-spin"></span>
                } @else {
                    <span translate="cart.button.submit"></span>
                }
            </button>
        </form>

        <customer-service></customer-service>
    </div>
</div>
